import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import FileDownloadRepository from '@/repositories/fileDownloadRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useFileDownloadStore = defineStore({
    id: 'fileDownload',
    state: () => ({}),
    actions: {
        /**
         * ダウンロード履歴取得処理
         */
        async getDownloadFileHistoryPkFromApi(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const fileDownloadRepository = new FileDownloadRepository();

            try {
                const response = await fileDownloadRepository.fileDownloadRepository(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * ダウンロード履歴更新処理
         */
        async updateDownloadFileHistoryPkFromApi(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const fileDownloadRepository = new FileDownloadRepository();

            try {
                const response = await fileDownloadRepository.putDownloadHistroyActionApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'put', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        //セッションストレージに保存
        //storage: sessionStorage,
    },
});
